import { render, staticRenderFns } from "./ExercisePreview.vue?vue&type=template&id=3bd448c5&"
import script from "./ExercisePreview.vue?vue&type=script&lang=js&"
export * from "./ExercisePreview.vue?vue&type=script&lang=js&"
import style0 from "./ExercisePreview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports